import { stripTags, viewItemUrl } from "@app/helpers"
import { FinResourceType, Headture, Labtest } from "../definitions/types"
import {
	booleanAttribute,
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { Modalable } from "@app/Modalable"
import { environment } from "@env/environment"
import * as moment from "moment"
import {
	BtnDropdownComponent,
	BtnExtComponent,
	CancelBtnComponent,
	SpinOrContent,
} from "@app/utils/utils.component"
import { ServerImgPipe } from "@app/utils/server-img.pipe"
import { InArrayPipe } from "@app/utils/in-array.pipe"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { SafeHtmlPipe } from "@app/utils/safe-html.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"
import { FinNumberPipe } from "@app/utils/finNumber.pipe"
import { NgTemplateOutlet } from "@angular/common"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ConfirmComponent } from "@app/confirm/confirm.component"
import { GenTableDisplayComponent } from "@app/gen-table-display/gen-table-display.component"

interface DownloadParams {
	arrRows?: any[]
	forceByEmail?: boolean
	send_phone?: string
	openInNewWindow?: Function
	getWhatsappLink?: boolean
	openPaymentTerminal?: boolean
}

@Component({
	selector: "app-preview-finresource",
	imports: [
		COMMON_IMPORTS,
		BtnExtComponent,
		ServerImgPipe,
		CancelBtnComponent,
		InArrayPipe,
		BtnDropdownComponent,
		SpinOrContent,
		LangValPipe,
		SafeHtmlPipe,
		DateFormatPipe,
		FinNumberPipe,
		NgTemplateOutlet,
		ModalWrapComponent,
		ConfirmComponent,
		GenTableDisplayComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./preview-finresource.component.html",
})
export class PreviewFinresourceComponent extends Modalable {
	modalProps: any = null
	randNum: number = Math.random()

	address: string = ""
	bn_number: string = ""

	@Input() doctype: FinResourceType = "invoice" //invoice, proforma, prescription, document, admininvoice, justinvoice,receipt,selfinvoice
	@Input() headtureRow: any = null
	@Input() finresourceObj: any = null
	@Input({ transform: booleanAttribute }) isDemoMode: boolean = false
	curRow: any = null
	dispDate: string = ""
	isSaving: boolean = false
	isCredit: boolean = false
	today: Date = new Date()
	@Input({ transform: booleanAttribute }) isEn: boolean = false
	@Input({ transform: booleanAttribute }) isDownloadOnly: boolean = false
	templates: any[] = [
		{ id: 1, name: "Template 1" },
		{ id: 2, name: "Template 2" },
		//{ id: 3, name: "Template 3" },
	]
	font: string = "Heebo"

	maxRows = 8
	vatPerc: number = 0
	isLogoWide: boolean = false
	curLang: any = null
	isAreasOpen: boolean = false
	sendOpts: any[] = []

	areasStructure: any[] = [
		{ area: "logo", row: 1, position: 2 },
		{ area: "headerText", row: 1, position: 0 },
		{ area: "date", row: 3, position: 2 },
		{ area: "title", row: 4, position: 1 },
		{ area: "for", row: 5, position: 0 },
		{ area: "table", row: 6, position: 1 },
		{ area: "remarks", row: 7, position: 0 },
		{ area: "signature", row: 8, position: 2 },
	]
	areaRows: any[] = []
	areaLocs: any[] = []
	areasStructureError: any = null
	areaSaving: boolean = false
	areaHasMoved: boolean = false

	ngOnDestroy() {
		document.getElementById("font-style-el")?.remove()
	}

	async ngOnInit() {
		//when called to open

		let cliniqData = this.store.cc()
		this.vatPerc = cliniqData.vat
		this.isLogoWide = cliniqData.wide_logo === "yes"
		this.isCredit = cliniqData?.credit_clearance

		if (this.headtureRow) {
			if (this.headtureRow?.areas) {
				this.areasStructure = JSON.parse(this.headtureRow.areas)
			} else {
				if (this.headtureRow.header_default == "l") {
					this.areasStructure = [
						{ area: "logo", row: 1, position: 2 },
						{ area: "headerText", row: 1, position: 0 },
						{ area: "date", row: 3, position: 2 },
						{ area: "for", row: 4, position: 0 },
						{ area: "title", row: 5, position: 1 },
						{ area: "table", row: 6, position: 1 },
						{ area: "remarks", row: 7, position: 0 },
						{ area: "signature", row: 8, position: 2 },
					]
				}
			}
		}

		this.sendOpts = [
			{ id: "sms", value: "send_sms_proforma1" },
			{ id: "whatsapp", value: "send_whatsapp_proforma" },
		]
		if (cliniqData.enable_payment_terminal === "yes") {
			this.sendOpts = [
				...this.sendOpts,
				{ id: "terminal", value: "open_payment_terminal" },
			]
		}

		if (this.finresourceObj) {
			this.apiService.decryptItem(this.finresourceObj)

			if (!this.finresourceObj.invoicelines) {
				this.finresourceObj.invoicelines = this.finresourceObj.invoicelines
			}
			if (
				this.finresourceObj.invoicelines &&
				this.finresourceObj.invoicelines.length
			) {
				this.finresourceObj.invoicelines.forEach((line) => {
					this.apiService.decryptItem(line)
					if (line.account_num == "0") {
						line.account_num = ""
					}
					line.value_date_display = moment
						.utc(line.value_date)
						.format("DD.MM.YY")
					line.repayment_date_display = moment
						.utc(line.repayment_date)
						.format("DD.MM.YY")
				})
			}
			if (["proforma", "justinvoice"].includes(this.finresourceObj.doctype)) {
				this.finresourceObj.invoicelines = []
			}
			if (this.finresourceObj.doctype == "prescription") {
				this.finresourceObj.date_display = moment
					.utc(this.finresourceObj.date)
					.format("DD.MM.YY")
				if (!this.finresourceObj.prescriptionLines) {
					this.finresourceObj.prescriptionLines =
						this.finresourceObj.prescriptionLines
				}
			}

			if (this.doctype == "document") {
				if (this.finresourceObj.date) {
					this.dispDate = this.finresourceObj.date
				}
				if (this.finresourceObj.html_content) {
					this.finresourceObj.html_content = this.finresourceObj.html_content
						.replaceAll("direction: ltr", "direction:ltr")
						.replaceAll("direction:ltr", "direction:ltr;text-align:left;")
				} else if (this.finresourceObj.html_content_dec) {
					this.finresourceObj.html_content_dec =
						this.finresourceObj.html_content_dec
							.replaceAll("direction: ltr", "direction:ltr")
							.replaceAll("direction:ltr", "direction:ltr;text-align:left;")
				}
				//convert html_content and/or html_content_dec - if direction:ltr -> add text-align:left;
			}

			this.loadData()
		} else {
			//change to invoicelines
			const doctype = this.headtureRow.header_default || "i"

			if (this.headtureRow) {
				const doctypeLettersToNames = {
					i: "invoice",
					l: "document",
					p: "prescription",
					n: "document",
				}
				this.doctype = doctypeLettersToNames[doctype] || "invoice"
			}

			const res: any = await this.apiService.post("get_headture_demo", {
				doctype,
			})
			this.finresourceObj = res.obj
			if (this.finresourceObj?.invoicelines?.length) {
				this.store.removeDecArr(this.finresourceObj.invoicelines)
			}
			if (this.doctype == "prescription") {
				this.store.removeDecItem(this.finresourceObj)
				this.store.removeDecArr(this.finresourceObj.prescriptionlines)
			}
			this.loadData()
		}

		document.getElementById("font-style-el")?.remove()
		if (this.doctype == "document") {
			const font = this.store.cc()?.default_font_for_documents
			if (font) {
				this.font = font
				// this.font="* {font-family: "+font+" || inherit}} !important;}";
				const style: any = document.createElement("style")
				style.type = "text/css"
				style.id = "font-style-el"
				style.innerText =
					"#preview-finresource *{font-family: " + font + " !important;}"
				document.body.appendChild(style)
			}
		}
		if (this.isDemoMode) {
			this.isAreasOpen = true
		}

		if (
			this.doctype == "document" &&
			this.finresourceObj.followup_id &&
			this.finresourceObj?.image_ids?.length &&
			!this.finresourceObj?.images?.length
		) {
			const images = await this.apiService.post("get_fp_images", {
				followup_id: this.finresourceObj.followup_id,
			})
			const image_ids = this.finresourceObj.image_ids
				.split(",")
				.map((it) => Number(it))
			this.finresourceObj.images = images.filter((image) =>
				image_ids.includes(image.id)
			)
		}
	}

	loadData() {
		if (!this.headtureRow) {
			//|| (!this.headtureRow.header_text && !this.headtureRow.signature_text)
			this.headtureRow = new Headture()
		}
		this.headtureRow = { ...this.headtureRow }
		this.headtureRow.header_text = this.headtureRow.header_text
			? this.headtureRow.header_text
					.split("\n")
					.filter((it) => it.trim().length)
					.map((it, ind) => {
						if (it.indexOf("@") != -1) {
							it = it
								? it
										.split(" ")
										.map((part) => {
											if (part.indexOf("@") != -1) {
												part =
													"<span class='ltr header-span-p' >" + part + "</span>"
											}
											return part
										})
										.join(" ")
								: ""
						}
						if (ind == 0) {
							return `<div   ><b class='header-span-p'>${it}</b></div>`
						}
						return `<div class='header-span-p'>${it}</div>`
					})
					.join("")
			: ""

		this.headtureRow.signature_text = this.headtureRow.signature_text
			? this.headtureRow.signature_text
					.split("\n")
					.map((it) => `<div class="sig-text"  >${it}</div>`)
					.join("")
			: ""
		// this.headtureRow.signature_text = this.headtureRow.signature_text ? this.headtureRow.signature_text.split("\n").join("&nbsp;".repeat(10) ) : "";

		if (this.finresourceObj) {
			if (this.finresourceObj?.remarks_dec) {
				this.finresourceObj.remarks = this.finresourceObj.remarks_dec
			}
			if (this.finresourceObj?.remarks) {
				this.finresourceObj.remarks = this.finresourceObj.remarks.replace(
					/\n/g,
					"<br />"
				)
			}

			if (this.finresourceObj.withholding_tax_percent) {
				this.finresourceObj.withholding_tax_percent = Number(
					this.finresourceObj.withholding_tax_percent
				)
				this.finresourceObj.withholding_tax = Number(
					this.finresourceObj.withholding_tax
				)
				this.finresourceObj.total_minus_withholding = Number(
					this.finresourceObj.total_minus_withholding
				)
				if (!this.finresourceObj.total_minus_withholding) {
					this.finresourceObj.total_minus_withholding =
						Number(this.finresourceObj.total) -
						this.finresourceObj.withholding_tax
				}
			}

			this.bn_number = this.finresourceObj?.bn_number

			if (this.finresourceObj.payor_id || this.finresourceObj.contact_id) {
				const tableName = this.finresourceObj.payor_id ? "payors" : "contacts"
				const obj = this.store.searchSiteDataItem(
					this.finresourceObj.payor_id || this.finresourceObj.contact_id,
					[tableName]
				)
				if (obj) {
					this.address = obj.address
					this.bn_number = this.bn_number || obj.bn_number
				}
			}
		}

		//assumes isEn
		this.curLang = this.lang[this.isEn ? "translationEn" : "translationHe"]
		this.onchangeAreas()
	}

	async saveOnly(isForSigning: boolean = false) {
		if (this.isSaving) {
			return
		}
		this.isSaving = true
		let sendObj = { ...this.finresourceObj, resource_type: this.doctype }
		if (isForSigning) {
			sendObj.for_signing = "yes"
		}

		const res: any = await this.apiService.post("save_finresource", sendObj)

		this.isSaving = false
		this.modalService.openToast("saved_successfully")
		this.preClose(res)
		this.store.addGenItemRow(
			"documents",
			{ ...this.store.removeDecItem(res) },
			{
				patient_id: res.patient_id,
				payor_id: res.payor_id,
				user_id: res.user_id,
			}
		)
		// this.store.renewFusesAndCalendar();
	}
	//totalMinusvat,total

	async download({
		arrRows,
		forceByEmail,
		send_phone,
		openInNewWindow,
		getWhatsappLink,
		openPaymentTerminal,
	}: DownloadParams = {}) {
		if (this.isSaving) {
			return
		}
		if (forceByEmail) {
			this.finresourceObj.by_email = "yes"
		}

		//  on English copy - isEn = true
		if (arrRows) {
			this.finresourceObj.emails_list = JSON.stringify(
				arrRows.map((row) => ({
					email: row.contactway,
					description: row.description,
					name: row.name,
				}))
			)
			this.finresourceObj.by_email = "yes"
		}
		this.finresourceObj.is_preview = "no"
		if (getWhatsappLink) {
			this.modalService.openToast("save_and_whatsapp")
		} else if (openPaymentTerminal) {
			this.modalService.openToast("open_payment_terminal")
		} else if (this.finresourceObj.by_email == "yes") {
			this.modalService.openToast("sent_to")
		} else {
			this.modalService.openToast("save_process")
		}
		let sendObj: any = { ...this.finresourceObj }

		if (this.doctype == "document") {
			sendObj.signed = "yes"
			// sendObj.headture_id=this.
		}

		if (this.isDownloadOnly) {
			sendObj = {
				...this.finresourceObj,
				id: this.finresourceObj.id,
				doctype: this.doctype,
				isEn: true,
			}
			this.preClose(sendObj)
			if (this.store.cc()?.download_documents === "no") {
				const res = await this.apiService.post("print_make_finresource", {
					...sendObj,
					isCreate: true,
				})
				this.modalService.openToast(
					res?.success ? "save_process" : "save_process"
				)
				if (openInNewWindow) {
					openInNewWindow(this.openViewUrl())
				}
				return null
			}

			await this.store.downloadToastFunc(async () => {
				const res = await this.apiService.download(
					"print_make_finresource",
					sendObj
				)
				this.apiService.downloadFile(
					res,
					`${this.doctype}_${this.finresourceObj.id}_copy_en.pdf`
				)
				this.modalService.openToast("download_success")
				if (openInNewWindow) {
					openInNewWindow(this.openViewUrl())
				}
			})
			return null
		}

		this.isSaving = true
		const res: any = await this.apiService.post("save_finresource", {
			resource_type: this.doctype,
			...sendObj,
		})
		if (res?.ita_message) {
			this.modalService.miscModalsSubj.next({
				name: "confirm-ita",
				freeText: res?.ita_message,
			})
		}

		this.preClose(res)

		this.isSaving = false
		this.finresourceObj.id = res.id

		// if (this.doctype == "invoice") {
		// }
		// else if (this.doctype == "document") {
		// 	this.store.addGenItemRow("documents", { ...this.store.removeDecItem(res) }, { patient_id: res.patient_id });
		// }
		sendObj = {
			id: this.finresourceObj.id,
			doctype: this.doctype,
			headture_id: this.headtureRow.id,
		}

		if (send_phone) {
			sendObj.send_phone = send_phone
		}

		if (this.finresourceObj?.by_email == "yes") {
			sendObj.by_email = "yes"
			sendObj.emails_list = this.finresourceObj?.emails_list || null
		}
		if (this.finresourceObj?.id_number) {
			sendObj.id_number = this.finresourceObj.id_number
		}

		if (this.store.cc()?.download_documents === "no") {
			const res2 = await this.apiService.post("print_make_finresource", {
				...sendObj,
				isCreate: true,
				isEn: this.isEn,
			})
			this.modalService.openToast(
				res2?.success ? "save_process" : "save_process"
			)
			if (res2?.success) {
				this.postDownload(res)
			}
			this.openVariousOpts(
				openInNewWindow,
				getWhatsappLink,
				openPaymentTerminal
			)
			return
		}

		this.store.downloadToastFunc(async () => {
			const res2 = await this.apiService.download("print_make_finresource", {
				...sendObj,
				isEn: this.isEn,
			})
			// this.store.renewFusesAndCalendar();
			if (!res2?.size) {
				return this.store.downloadFailedModal()
			}

			await this.openVariousOpts(
				openInNewWindow,
				getWhatsappLink,
				openPaymentTerminal
			)

			this.modalService.openToast("download_success")
			this.postDownload(res)
			this.apiService.downloadFile(
				res2,
				`${this.doctype}_${this.finresourceObj.id}_original.pdf`
			)
		})
	}
	async openVariousOpts(openInNewWindow, getWhatsappLink, openPaymentTerminal) {
		if (openInNewWindow) {
			await openInNewWindow(this.openViewUrl())
		}
		if (getWhatsappLink) {
			await this.sendWhatsapp()
		}
		if (openPaymentTerminal) {
			const res: any = await this.apiService.post("contact_payment_terminal", {
				id: this.finresourceObj.id,
				doctype: this.doctype,
			})
			if (res.link) {
				;(window.location.href as any) = res.link
			}
		}
	}
	downloadNewWnd() {
		this.download({ openInNewWindow: this.apiService.openDelayedUrl() })
	}
	openViewUrl() {
		return viewItemUrl(this.finresourceObj.id, this.doctype, this.isEn)
	}
	postDownload(res: any) {
		if (this.doctype != "admininvoice") {
			this.store.addGenItemRow(
				this.doctype + "s",
				{ ...this.store.removeDecItem(res) },
				{
					patient_id: res.patient_id,
					payor_id: res.payor_id,
					user_id: res.user_id,
				}
			)
			this.store.callFinresourceActionSub() //both refresh table for finresources/open_proformas
		}
	}
	async sendSms() {
		const patient = await this.store.getPatient(this.finresourceObj.patient_id)
		const phone = this.store.getPhoneContactway(patient, "sms")
		if (!phone) {
			this.modalService.openToast("no_valid_phone")
			return
		}
		this.modalProps = {
			name: "confirm-sms",
			phone,
			freeText:
				"<div>" +
				this.lang.getVal("dear") +
				" " +
				patient?.name +
				", </div><div>" +
				this.lang.getVal("your_balance_at") +
				" " +
				this.store.cc().name +
				" " +
				this.lang.getVal("is") +
				" " +
				this.finresourceObj.total +
				" " +
				this.lang.getVal("coin") +
				", </div></br>" +
				"<div>   " +
				this.lang.getVal("link_will_be_sent") +
				" " +
				phone.contactway +
				"</div>",
		}
	}
	handleSmsConfirm() {
		const { phone } = this.modalProps
		this.modalProps = null
		this.download({ send_phone: phone.contactway })
	}
	async sendWhatsapp() {
		const cliniqData = this.store.cc()
		const patient = await this.store.getPatient(this.finresourceObj.patient_id)
		const phone = this.store.getPhoneContactway(patient, "whatsapp")
		if (!phone) {
			this.modalService.openToast("no_valid_phone")
			return
		}

		// console.log(stripTags(this.finresourceObj.payment_details))

		let freeText =
			this.lang.getVal("dear") +
			" " +
			patient?.name +
			"  %0A" +
			this.lang.getVal("your_balance_at") +
			" " +
			cliniqData.name +
			" " +
			this.lang.getVal("is") +
			" " +
			this.finresourceObj.total +
			" " +
			this.lang.getVal("coin")

		if (this.isCredit) {
			const crLink = await this.apiService.post("get_client_purchase_cr_link", {
				id: this.finresourceObj.id,
				doctype: this.doctype,
			})
			freeText +=
				" %0A" +
				this.lang.getVal("to_pay_please_click_on_the_link") +
				"  %0A" +
				crLink.link.replaceAll("\r", "%0A")
		}

		const waphone = phone?.contactway.substring(1)
		console.log(this.store.getWhatsappUrl(waphone, freeText), "_blank")
		window.open(this.store.getWhatsappUrl(waphone, freeText), "_blank")

		return
	}

	async openContactwaysModal() {
		//
		if (this.finresourceObj.user_id) {
			this.download({ forceByEmail: true })
			return
		}
		let preChosenItems: any = null
		if (this.finresourceObj?.email_details) {
			preChosenItems = {
				fieldName: "contactway",
				values: this.finresourceObj.email_details.split(","),
			}
		}

		const fieldName = this.store.getPersonFieldName(this.finresourceObj)

		this.modalProps = {
			name: "table-display-contactways",
			filterField: fieldName,
			...this.store.phoneEmailValidationAttrs(),
			preChosenItems,
		}
	}
	handleContactwaysClose(arr: any[]) {
		this.download({ arrRows: arr })
		this.curRow = null
	}
	////////////////////

	onchangeAreas() {
		//if 2 items - must be right-left
		this.areasStructureError = null

		const rowsObj = {}
		this.areasStructure.forEach((areaRow) => {
			areaRow.error = null
			if (!rowsObj[areaRow.row]) {
				rowsObj[areaRow.row] = []
			}
			rowsObj[areaRow.row].push(areaRow)
		})

		this.areaLocs = []
		for (let i = 0; i < this.maxRows; i++) {
			this.areaLocs[i] = [null, null, null]
		}

		Object.keys(rowsObj).forEach((key) => {
			const row = rowsObj[key]
			row.forEach((item) => {
				const col = item.position

				this.areaLocs[item.row - 1][col] = item
			})
		})

		for (let rowKey of Object.keys(rowsObj)) {
			const row = rowsObj[rowKey]

			if (row.length > 2) {
				//row can have either 1 or 2 items
				row[0].error = this.lang.getVal("row_can_have_either_1_or_2_items")
				return (this.areasStructureError = true)
			}
			if (row.length == 2) {
				//can only be right and left, must be different
				if (row[0].position == row[1].position) {
					row[0].error = this.lang.getVal(
						"if_row_has_2_they_can_only_be_right_and_left"
					)
					return (this.areasStructureError = true)
				}
				if (row[0].position == 1) {
					row[0].error = this.lang.getVal("if_center_only_one_item")
					return (this.areasStructureError = true)
				}
				if (row[1].position == 1) {
					row[1].error = this.lang.getVal("if_center_only_one_item")
					return (this.areasStructureError = true)
				}
			}
		}

		this.areaRows = []
		Object.keys(rowsObj).forEach((key) => this.areaRows.push(rowsObj[key]))
		this.areaRows
			.filter((r) => r.length == 2)
			.forEach((row) => row.sort((a, b) => (a.position == 2 ? 1 : -1)))
	}

	async saveAreas() {
		const areas = JSON.stringify(this.areasStructure)
		this.areaSaving = true
		await this.apiService.post("save_headture_areas", {
			id: this.headtureRow.id,
			areas,
		})
		this.areaHasMoved = false
		this.areaSaving = false
		this.modalService.openToast("saved_successfully")
		const fields = [this.store.crGenTableUpdateField("areas", "areas")]
		this.store.updateGenTable(
			"headtures",
			[{ id: this.headtureRow.id, areas }],
			fields
		)
	}

	areaLocIsOccupied(item: any, newPosItem: any) {
		const newItem = { ...item, ...newPosItem }
		const posInArr = newItem.row - 1
		return this.areaLocs[posInArr][newItem.position]
	}

	arrowMove(item: any, dir: "up" | "down" | "back" | "for") {
		if (dir == "up" && item.row > 1) {
			if (!this.areaLocIsOccupied(item, { row: item.row - 1 })) {
				item.row--
				this.areaHasMoved = true
			}
		}
		if (dir == "down" && item.row < this.maxRows) {
			if (!this.areaLocIsOccupied(item, { row: item.row + 1 })) {
				item.row++
				this.areaHasMoved = true
			}
		}

		const curPos = item.position
		if (dir == "back" && curPos != 0) {
			const newPos = curPos - 1
			if (!this.areaLocIsOccupied(item, { position: newPos })) {
				item.position = newPos
				this.areaHasMoved = true
			}
		}
		if (dir == "for" && curPos != 2) {
			const newPos = curPos + 1
			if (!this.areaLocIsOccupied(item, { position: newPos })) {
				item.position = newPos
				this.areaHasMoved = true
			}
		}

		this.onchangeAreas()
	}
	async handleSaveChangesConfirm(sendObj: any, approved: boolean = false) {
		this.modalProps = null
		if (approved) {
			await this.saveAreas()
		}
		this.onClose.emit(sendObj)
	}
	handleAreaErrorConfirm(sendObj: any) {
		this.modalProps = null
		if (this.areaHasMoved) {
			this.modalProps = { name: "confirm-save-changes", sendObj }
			return
		}
		this.handleSaveChangesConfirm(sendObj)
	}
	preClose(sendObj: any = null) {
		if (this.areaHasMoved && this.areasStructureError) {
			this.modalProps = { name: "confirm-area-error-close", sendObj }
			return
		}

		this.handleAreaErrorConfirm(sendObj)
	}
	sendLink(value: string) {
		console.log(value)
	}
	handleSendOption(opt: any) {
		if (opt === "sms") {
			this.sendSms()
		} else if (opt === "whatsapp") {
			this.download({ getWhatsappLink: true })
		} else {
			this.download({ openPaymentTerminal: true })
		}
	}
}
